import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/frontend/src/app/doc/[[...id]]/page.tsx");
